import './oiHeaderLite.css';
import React from 'react';
import History from '../../History';
import BurgerIcon from 'react-icons/lib/fa/bars';
import LeftAngleIcon from 'react-icons/lib/fa/angle-left';

const oiHeaderLite = (props) => {
    const date = new Date();
    const daysOfWeek = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
    const monthsOfYear = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    const day = date.getDate();
    const weekDay = daysOfWeek[date.getDay()];
    const month = monthsOfYear[date.getMonth()];

    const finalDate = weekDay + ', ' + day + ' de ' + month;

    const newsRedirect = () => {
        History.push(`${process.env.PUBLIC_URL}/noticias`);
        window.location.reload();
    };

    return (
        <header id="oi-header-lite">
            {
                props.isBundle ?
                    <BurgerIcon
                        id="oi-header-lite-icon"
                        onClick={props.clickEvent}
                    />
                    :
                    sessionStorage.getItem('sessionToken') ?
                        <LeftAngleIcon
                            id="oi-header-lite-icon"
                            onClick={props.clickEvent}
                        /> :
                        ''
            }

            <span id="oi-header-lite-date">{finalDate}</span>
            <h1 id="oi-header-lite-title" onClick={newsRedirect}>Clic News</h1>

        </header>
    );
};

export default oiHeaderLite;


// WEBPACK FOOTER //
// ./src/components/oiHeaderLite/oiHeaderLite.js